import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import SignatureRolloutService from '../../services/signature/SignatureRolloutService'

export default function SignatureRolloutGuard({ children }) {
    const [state, setState] = useState({ loading: true, allowed: false })

    useEffect(() => {
        let mounted = true
        SignatureRolloutService.getMyPolicy()
            .then(res => {
                const policy = res?.data?.data || res?.data || {}
                if (mounted) setState({ loading: false, allowed: policy.signatureRequired === true })
            })
            .catch(() => {
                if (mounted) setState({ loading: false, allowed: false })
            })
        return () => { mounted = false }
    }, [])

    if (state.loading) return <div className="d-flex justify-content-center align-items-center p-5">Memuat kebijakan TTE...</div>
    if (!state.allowed) return <Navigate to="/dashboard" replace />
    return children
}
